export enum NotificationsRoutes {
  ROOT = '',
  ALERTS = 'alerts',
  PREFERENCES = 'preferences',
  CUSTOM_NOTIFICATION = 'custom-notification'
}
